import { makeAutoObservable } from "mobx"
import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"

const initialBoard = Array(9).fill(null)

export default class TicTacToeStore {
   board = initialBoard
   currentPlayer = 'X'
   gameActive = false
   result: string | null = null

   constructor() {
      makeAutoObservable(this)
   }

   printBoard = (board?: (null | 'X' | 'O')[]) => {
      board ??= this.board
      const cell = (i: number) => board[i] || (i + 1).toString()
      return `\n${cell(0)}  |  ${cell(1)}  |  ${cell(2)}\n---------\n${cell(3)}  |  ${cell(4)}  |  ${cell(5)}\n---------\n${cell(6)}  |  ${cell(7)}  |  ${cell(8)}`
   }

   makeMove = (index: number): string | null => {
      if (!this.gameActive || this.board[index]) return null

      const newBoard = [...this.board]
      newBoard[index] = this.currentPlayer
      let winner = this.checkWinner(newBoard)

      if (winner || !newBoard.includes(null)) {
         this.board = newBoard
         this.currentPlayer = this.currentPlayer === 'X' ? 'O' : 'X'
         this.gameActive = false
         this.result = winner ? `You won!` : 'Draw!'
         return `${this.printBoard(newBoard)}\n${this.result}`
      }

      this.board = newBoard
      this.currentPlayer = 'O'

      const botMove = this.getRandomEmptyIndex()
      if (botMove !== null) {
         this.board[botMove] = 'O'
         winner = this.checkWinner(this.board)
         if (winner || !this.board.includes(null)) {
            this.gameActive = false
            this.result = winner ? `You lost!` : 'Draw!'
            return `${this.printBoard(this.board)}\n${this.result}`
         }
      }

      this.currentPlayer = 'X'
      return `${this.printBoard(this.board)}\nYour move:`
   }

   checkWinner = (board: (null | 'X' | 'O')[]) => {
      const winLines = [
         [0, 1, 2], [3, 4, 5], [6, 7, 8],
         [0, 3, 6], [1, 4, 7], [2, 5, 8],
         [0, 4, 8], [2, 4, 6]
      ]
      for (const [a, b, c] of winLines) {
         if (board[a] && board[a] === board[b] && board[a] === board[c]) return board[a]
      }
      return null
   }

   getRandomEmptyIndex = (): number | null => {
      const emptyIndexes = this.board
         .map((val, i) => (val === null ? i : null))
         .filter((i): i is number => i !== null)
      if (emptyIndexes.length === 0) return null
      return emptyIndexes[Math.floor(Math.random() * emptyIndexes.length)]
   }

   startGame = () => {
      this.board = initialBoard
      this.currentPlayer = 'X'
      this.gameActive = true
      this.result = null
   }

   reset = () => {
      this.board = initialBoard
      this.currentPlayer = 'X'
      this.gameActive = false
      this.result = null
   }
}

export const { Provider: TicTacToeStoreProvider, useProvidedStore: useTicTacToeStore } = createStoreContext(TicTacToeStore)
